export default __webpack_public_path__ + "images/c07fc8ed87ee1b35397b8c3332e5c9d2.png";